/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbItemUtils } from "abreact/misc/AbItemUtils";
import { StringUtils } from "abweb/utils/StringUtils";
import * as React from "react";
export let AbFilterUtils;
(function (_AbFilterUtils) {
  const boldMatch = _AbFilterUtils.boldMatch = (item, matcher) => {
    let matcherRegex;
    if (typeof matcher === "string") {
      if (matcher.length === 0) {
        return item;
      }
      matcherRegex = new RegExp(StringUtils.escapeRegExp(matcher), 'gi');
    } else {
      matcherRegex = matcher;
    }
    const matches = [...item.matchAll(matcherRegex)].filter(m => m[0].length > 0);
    if (matches.length === 0) return item;
    const returnArray = [];
    let nonMatchingSubstring = item.substring(0, matches[0].index);
    returnArray.push(/*#__PURE__*/React.createElement("span", {
      key: `${0}-${nonMatchingSubstring}`
    }, nonMatchingSubstring));
    for (let i = 0; i < matches.length; i++) {
      returnArray.push(/*#__PURE__*/React.createElement("span", {
        key: `match-${i}-${matches[i]}`,
        className: "ab-matched-text"
      }, matches[i]));
      nonMatchingSubstring = item.substring(matches[i].index + matches[i][0].length, matches.at(i + 1)?.index);
      returnArray.push(/*#__PURE__*/React.createElement("span", {
        key: `${i + 1}-${nonMatchingSubstring}`
      }, nonMatchingSubstring));
    }
    return returnArray;
  };
  const boldMatchRenderer = _AbFilterUtils.boldMatchRenderer = (item, enrichment, filterProps) => {
    const defaultDisplayName = AbItemUtils.defaultItemDisplayName(item, enrichment);
    if (!filterProps.isMatch || !filterProps.filterString) return defaultDisplayName;
    return AbFilterUtils.boldMatch(defaultDisplayName, filterProps.filterString);
  };
  const boldMatchPrefixRenderer = _AbFilterUtils.boldMatchPrefixRenderer = (item, enrichment, filterProps) => {
    const defaultDisplayName = AbItemUtils.defaultItemDisplayName(item, enrichment);
    if (!filterProps.isMatch || !filterProps.filterString) return defaultDisplayName;
    const regex = new RegExp(`^${StringUtils.escapeRegExp(filterProps.filterString)}`, "gi");
    return AbFilterUtils.boldMatch(defaultDisplayName, regex);
  };
  const boldMatchPathRenderer = _AbFilterUtils.boldMatchPathRenderer = (item, enrichment, treeProps) => {
    if (treeProps.isMatch) return boldMatchRenderer(treeProps.enrichedPath.map(pathItem => AbItemUtils.defaultItemDisplayName(pathItem)).join("/"), undefined, treeProps);
    return boldMatchRenderer(item, enrichment, treeProps);
  };
  /**
   * Returns a sorted array of text ranges where any overlapping ranges in the input array are merged.
   */
  const sortAndMergeRanges = _AbFilterUtils.sortAndMergeRanges = ranges => {
    if (ranges.length === 0) {
      return ranges;
    }
    const sortedRanges = ranges.sort((matchA, matchB) => matchA.startOffset - matchB.startOffset);
    const returnArray = [sortedRanges[0]];
    for (let i = 1; i < sortedRanges.length; i++) {
      const currentRange = sortedRanges[i];
      const lastRange = {
        ...returnArray[returnArray.length - 1]
      };
      if (lastRange.endOffset < currentRange.startOffset) {
        returnArray.push(currentRange);
      } else if (lastRange.endOffset < currentRange.endOffset) {
        lastRange.endOffset = currentRange.endOffset;
        returnArray.pop();
        returnArray.push(lastRange);
      }
    }
    return returnArray;
  };
  const boldMatchWithRanges = _AbFilterUtils.boldMatchWithRanges = (item, ranges) => {
    const validRanges = ranges.filter(range => range.startOffset >= 0 && range.endOffset <= item.length);
    if (validRanges.length === 0) {
      return item;
    }
    const sortedRanges = AbFilterUtils.sortAndMergeRanges(validRanges);
    const returnArray = [];
    returnArray.push(item.substring(0, sortedRanges[0].startOffset));
    for (let i = 0; i < sortedRanges.length; i++) {
      const match = item.substring(ranges[i].startOffset, ranges[i].endOffset);
      returnArray.push(/*#__PURE__*/React.createElement("span", {
        className: "ab-matched-text",
        key: `match-${i + 1}-${match}`
      }, match));
      if (i < sortedRanges.length - 1) {
        returnArray.push(item.substring(ranges[i].endOffset, ranges[i + 1].startOffset));
      } else {
        returnArray.push(item.substring(ranges[i].endOffset, item.length));
      }
    }
    return returnArray;
  };
  const FILTER_FUNCTIONS = _AbFilterUtils.FILTER_FUNCTIONS = {
    /** case-insensitive prefix matching */
    PREFIX: (filterString, item, enrichment) => {
      const itemString = AbItemUtils.defaultItemDisplayName(item, enrichment);
      return itemString.toLowerCase().startsWith(filterString.toLowerCase());
    },
    /** case-insensitive suffix matching */
    SUFFIX: (filterString, item, enrichment) => {
      const itemString = AbItemUtils.defaultItemDisplayName(item, enrichment);
      return itemString.toLowerCase().endsWith(filterString.toLowerCase());
    },
    /** case-insensitive substring matching */
    SUBSTRING: (filterString, item, enrichment) => {
      const itemString = AbItemUtils.defaultItemDisplayName(item, enrichment);
      return itemString.toLowerCase().includes(filterString.toLowerCase());
    }
  };
})(AbFilterUtils || (AbFilterUtils = {}));
//# sourceMappingURL=AbFilterUtils.js.map
